var elemHideFeaturedButton = document.getElementById('hideFeaturedButton');
if ((typeof(elemHideFeaturedButton) != 'undefined') && (elemHideFeaturedButton != null))
{
    elemHideFeaturedButton.addEventListener('click', function(event){
        event.preventDefault();
        document.getElementById('html').className += ' hideFeatured';
        window.setCookie('mr-hidefeatured',Math.round((new Date()).getTime() / 1000), 365);
    });
}

if (window.hideFeatured)
    {
    	var elemFeatured = document.getElementById('featured');
    	if ((typeof(elemFeatured) != 'undefined') && (elemFeatured != null))
    	{
			var featuredtime = parseInt(document.getElementById('featured').getAttribute('data-timestamp'));
			if (hideFeatured < featuredtime)
			{
				window.eraseCookie('mr-hidefeatured');
				document.getElementById('html').classList.remove("hideFeatured");
			}
		}
    }

